import React, { useState } from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { CheckboxComponent, TextFieldComponent } from '../../components/CustomFormElement'
import validators from '../../utils/validators';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { paths } from '../../config/router.config';
import { EmailIcon, EmailWhiteIcon, PasswordHideWhiteIcon, PasswordShowWhiteIcon, PhoneInputWhiteIcon } from '../../components/CustomIcons';
import theme, { commonFont } from '../../theme.css';
import CustomSection from '../../components/CustomSection';
import { DataGrid } from '@mui/x-data-grid';
import classNames from 'classnames';
import CustomTabs from '../../components/CustomTabs';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    //table: 
    cell: {
        fontFamily: commonFont.regular,
    },
    columnSeparator: {
        display: 'none!important'
    }
}));

export default function NotificationsView(props){
    const classes = useStyles();
    const {t} = useTranslation();

    const [active, setActive] = useState('unread');
    const [data, setData] = useState([]);

    const onChangeTab = (value) => {
        setActive(value);
    }

    const columns = [
        { field: 'id', headerName: 'Number', flex: 1, sortable: false},
        { field: 'date', headerName: 'Date', flex: 1, sortable: false},
        { field: 'subject', headerName: 'Subject', flex: 1, sortable: false},
        {
            field: 'action',
            headerName: '',
            sortable: false,
            renderCell: (params) => {
              return <Button variant='text' onClick={() => props.onDetail(params)}>{t('btn_detail')}</Button>;
            },
          },
    ];
    const rows = [
        { id: 112233, date: '30/12/2021 19:08', subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illum hic quasi quae, dolorem. Dignissimos, sed excepturi ad praesentium beatae labore dolores, ullam fugiat doloremque, dolorem ipsa mollitia earum unde ut.' },
        { id: 112234, date: '30/12/2021 19:08', subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit.' },
        { id: 112235, date: '31/12/2021 19:08', subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit.' },
    ]

    const itemsTab = [
        {
            value: 'unread',
            label: 'Unread'
        },
        {
            value: 'read',
            label: 'Read'
        },
    ];
    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true} 
                title={t('notifications')} 
                icon={<EmailIcon style={{
                    color: theme.palette.common.white,
                }}/>}
                customClass={classes.customClass}
            >
                <CustomTabs 
                    active={active}
                    items={itemsTab}
                    showCount={true}
                    count={1}
                    onChangeTab={onChangeTab}
                />
                <Grid item xs={12} marginTop={1}>
                    <Grid item xs={12} style={{ height: 350, width: '100%' }}>
                        <DataGrid
                            classes={{
                                cell: classes.cell,
                                columnSeparator: classes.columnSeparator,
                                menuIcon: classes.columnSeparator,
                            }}
                            rows={rows}
                            columns={columns}
                            rowsPerPageOptions={[10]}
                            onCellDoubleClick={(item) => props.onDetail(item)}
                            // hideFooter={true}
                        />
                    </Grid>
                </Grid>
            </CustomSection>
        </Grid>
    );
}
